import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";
import "../styles/MgmtRequests.css";
import "../../App.css";

export default function MgmtRequests() {

  const topbarItem = [
    { path: "manage/requests/all", name: "All" },
    { path: "manage/requests/to-pay", name: "To Pay" },
    { path: "manage/requests/to-process", name: "To Process" },
    { path: "manage/requests/to-receive", name: "To Receive" },
    { path: "manage/requests/done", name: "Done" },
  ];

  const [errorRequests, setErrorRequests] = useState({
    type: "",
    message: ""
  });  
  
  const [selectedTab, setSelectedTab] = useState("All");

  // for testing, set requests_data initial state to example_data
  const [requests_data, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);

  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [userRole, setUserRole] = useState('');
  const userIdRef = useRef('');
  const userRoleRef = useRef('');

  useEffect(() => {
    document.title = "Manage Requests"; // Set the tab name
    handleRadioChange("All");

    axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true })
    .then((res) => {
      // console.warn("is the session alive in singlerequest? ", res.data);
      if (res.data.status === 1) {
        setUserId(res.data.id);
        userIdRef.current = res.data.id;
        setUserRole(res.data.role);
        userRoleRef.current = res.data.role;
      } 
    })
    .catch((err) => {
      //console.error("ERROR: Your session cannot be found!", err);
  
    });  

    if (!userRoleRef.current) {
      const id_loggedClient = userIdRef.current;
      
      axios.get(`https://docuquest-swu.swucite.tech/api_drts/transactionsClient.php/${id_loggedClient}/`)
      .then((response) => {
        //console.warn("got data: ", response.data);
        const requests = response.data.map((request) => ({
        // TODO update for current transactions.sql
          id: request.TCN_id,
          reference: request.TCN_reference_number,
          id_doc: request.TCN_id_doc,
          name_requester: request.TCN_name_req,
          phone_requester: request.TCN_phone_req,
          email_requester: request.TCN_email_req,
          id_swustudent: request.TCN_id_swu,
          id_owner: request.TCN_id_owner, 
          name_owner: request.TCN_name_owner,
          phone_owner: request.TCN_phone_owner,
          course: request.TCN_course, 
          filepath_receipt: request.TCN_filepath_receipt || "No receipt",
          statusPayment: request.TCN_statusPayment,
          statusRequest: request.TCN_statusTransit,
          daysOverdue: request.TCN_overdue_days,
          id_employee: request.TCN_id_employee,
          requestedAt: request.TCN_created_at,
          updatedAt: request.TCN_updated_at,
        }));

        setRequests(requests);
        setFilteredRequests(requests);
      })
      .catch((err) => setErrorRequests({ type:"danger", message:`ERROR: Cannot retrieve requests for "${id_loggedClient}": ${err}` }));
    }
  }, []);
  
  const [searchValue, setSearchValue] = useState("");
  
const handleRadioChange = (name) => {
  setSelectedTab(name);
  
  const filteredByRadiobutton = requests_data.filter((request) => {
        switch (name) {
          case "All":
            return true;
          case "To Pay":
            return request.statusPayment === "Not Paid";
            case "To Process":
              return request.statusRequest === "Accepted";
              case "To Receive":
            return request.statusRequest === "In Review";
          case "Done":
            return request.statusRequest === "Done";
          default:
            return true;
          }
        });

  const filteredBySearch = filteredByRadiobutton.filter((request) =>
    Object.values(request).some((val) =>
    String(val).toLowerCase().includes(searchValue.toLowerCase())
    
  ));
        
  setFilteredRequests(filteredBySearch);
  setPageNow(1);
};
    
const handleSearchChange = (e) => {
      const searchQuery = e.target.value.toLowerCase();
      setSearchValue(searchQuery);

      if (searchQuery === "") {
        // Reset filtered requests to only apply the radio button filter
        handleRadioChange(selectedTab);
        return;
      }

      const filteredBySearch = requests_data.filter((request) =>
        Object.values(request).some((val) =>
        String(val).toLowerCase().includes(searchValue.toLowerCase())
      ));
  
    const filteredByRadiobutton = filteredBySearch.filter((request) => {
      switch (selectedTab) {
        case "All":
          return true;
          case "To Pay":
            return request.statusPayment === "Not Paid";
            case "To Process":
              return request.statusRequest === "Accepted";
              case "To Receive":
                return request.statusRequest === "In Review";
                case "Done":
                  return request.statusRequest === "Done";
                  default:
                    return true;
      }
    });

    setFilteredRequests(filteredByRadiobutton);
    setPageNow(1);    
  }
  
  const getStatusPayment = (statusPayment) => {
    switch (statusPayment) {
      case "Paid":
        return "payment-status paid";
      case "Not Paid":
        return "payment-status not-paid";
      default:
        return "";
    }
  };

  const getStatusTransit = (statusRequest) => {
    switch (statusRequest) {
      case "Accepted":
        return "status in-progress";
      case "Request Placed":
        return "status queue";
      case "In Review":
        return "status in-review";
      case "Done":
        return "status done";
      default:
        return "";
    }
  };
  
  const [pageNow, setPageNow] = useState(1);
  const rowsNow = 15;
  const indxLast = pageNow * rowsNow;
  const indxFirst = indxLast - rowsNow;
  
  const paginatedRequests = filteredRequests.slice(indxFirst, indxLast);
  const pageTotal = Math.ceil(filteredRequests.length / rowsNow);
  const pageNumbers = [...Array(pageTotal + 1).keys()].slice(1);
  
  const pagePrev = () => {
    if (pageNow > 1) setPageNow(pageNow - 1);
  };
  
  const pageNext = () => {
    if (pageNow < pageTotal) setPageNow(pageNow + 1);
  };

  const changePage = (id) => {
    setPageNow(id);
  };
  
  const handleNavigation = (path) => {
    navigate(path);
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp); // Convert timestamp to Date object
    return date.toLocaleDateString('en-US', {
        month: 'short', // "Oct"
        day: 'numeric', // "6"
        year: 'numeric' // "2024"
    });
  };

 {/* TODO archives
    - button documents archive 
    - button transactions archive
  */}      

  return (
    <div className="mgmt-users">
      <header className="header">
        <h1>My Requests</h1>
        <input
          type="text"
          placeholder="Search"
          value={searchValue}
          onChange={handleSearchChange}
          className="search-input right"
        />
      </header>

      <section className="topbar client">
  <Form>
    {topbarItem.map((item, index) => (
      <div
        key={`option-${index}`}
        title={item.name}
        className={`item_topbar ${selectedTab === item.name ? "active" : ""}`}
        onClick={() => handleRadioChange(item.name)}
      >
        <Form.Check
          inline
          label={item.name}
          name="topbarOptions"
          type="radio"
          checked={selectedTab === item.name}
          style={{ display: "none" }}
          onChange={() => handleRadioChange(item.name)}
        />
        {item.name}
      </div>
    ))}
  </Form>
</section>
  {errorRequests ? (
    <Alert variant={errorRequests.type}>
      {errorRequests.message}
    </Alert>
  ) : ""
  }
      <table className="documents-table">
        <thead>
          {requests_data.length > 0 && (
            <tr>
              <th>Document</th>
              <th>Receipt</th>
              <th>Created At</th>
              <th>Updated At</th>
              <th>Payment</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          )}
        </thead>
        <tbody>
          {paginatedRequests.length > 0 ? (
            paginatedRequests.map((request) => (
              <tr
                key={request.id}
                onClick={() => navigate(`/tracking/${request.reference}`)}
              >
                <td>
                  <div className="requester-info" title={request.purpose_req}>
                    {/*
                    TODO get image src from receipt picture 
                    <img
                      src="https://placehold.co/40x40"
                      title=""
                      alt="Avatar"
                      className="avatar"
                    /> */}
                    <div>
                      <div>{request.purpose_req}</div>
                      <div className="role">{request.desc_req}</div>
                    </div>
                  </div>
                </td>
                <td>{request.filepath_receipt}</td>
                <td>{formatDate(request.requestedAt)}</td>
                <td>{formatDate(request.updatedAt)}</td>
                <td className={getStatusPayment(request.statusPayment)}>
                  {request.statusPayment}
                </td>
                <td className={getStatusTransit(request.statusRequest)}>
                  {request.statusRequest}
                </td>
                <td>
                {(request.filepath_receipt === "No receipt") && (
                  <Button
                    title="Click to add receipt"
                    onClick={() => handleNavigation(`/tracking/${request.reference}`)}
                    variant="outline-warning"
                    size="sm"
                  >
                    Add&nbsp;receipt
                  </Button>
                )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="no-results">
                No results for "{searchValue}" in {selectedTab}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {paginatedRequests.length > 0 && (
        <div className="pagination">
          <button onClick={() => changePage(1)} disabled={pageNow === 1}>
            &lt;&lt;
          </button>
          <button onClick={pagePrev} disabled={pageNow === 1}>
            &lt; Previous
          </button>
          {pageNumbers.map((number) => (
            <button
              key={number}
              onClick={() => changePage(number)}
              className={pageNow === number ? "active" : ""}
            >
              {number}
            </button>
          ))}
          <button onClick={pageNext} disabled={pageNow === pageTotal}>
            Next &gt;
          </button>
          <button onClick={() => changePage(pageTotal)} disabled={pageNow === pageTotal}>
            &gt;&gt;
          </button>
        </div>
      )}
      {/* TODO css class for position */}
      <Button title="Add new request" onClick={() => handleNavigation('/request')} style={{ width: '50px', height: '50px', borderRadius: '50%', float: 'right', }} variant="dark" size="lg">+</Button>
    </div>
  );
}